import React, { use, useEffect, useState } from 'react';
import useDashboardHome from './useDashboardHome';
import NoDataFound from '../NoDataFound/NoDataFound';
import { useOption } from '../../../../context/OptionContext';
import KpiAccordion from './KpiCard';
import { usePermissions } from '../../../../context/PermissionContext';

const SalesCard = ({ formattedStart, formattedEnd , type,permission}) => {
  const { loadingState, dashboardSummary, getDashboardSummaryCard } = useDashboardHome();
  const { selectedOption } = useOption();
  const [showAll, setShowAll] = useState(false);
  const [visibleCount, setVisibleCount] = useState(6);
  const [activeTooltipIndex, setActiveTooltipIndex] = useState(null);
  const [prevData, setPrevData] = useState({});
const sectionPermissionMap = {
  "Topline Growth": "topline_growth",
  "Orders & Units": "growth_and_risk",
  "Risk Indicators": "risk_indicators",
  "Traffic & Conversion": "traffic_and_conversion",
  "Profit Leaks": "profit_leaks"
};
  useEffect(() => {
    getDashboardSummaryCard({ formattedEnd, formattedStart });
  }, [formattedStart, formattedEnd,selectedOption?.id]);

  useEffect(() => {
    if (!loadingState?.dashboardSummary && dashboardSummary && Object.keys(dashboardSummary).length > 0) {
      setPrevData(dashboardSummary);
    }
  }, [loadingState?.dashboardSummary, dashboardSummary]);

  useEffect(() => {
    const calculateVisibleCount = () => {
      const width = window.innerWidth;
      if (width >= 1800) return 6;
      if (width >= 1600) return 5;
      if (width >= 1400) return 4;
      if (width >= 1200) return 3;
      if (width >= 768) return 2;
      if (width >= 389) return 1;
      return 2;
    };
    const updateVisibleCount = () => setVisibleCount(calculateVisibleCount());
    updateVisibleCount();
    window.addEventListener('resize', updateVisibleCount);
    return () => window.removeEventListener('resize', updateVisibleCount);
  }, []);

  const isEmpty = !prevData || Object.keys(prevData).length === 0;
  const allCards = Object.entries(prevData);
  const initialCards = allCards.slice(0, visibleCount);
  const remainingCards = allCards.slice(visibleCount);
  const displayedCards = showAll ? allCards : initialCards;


  const toggleTooltip = (index) => {
    setActiveTooltipIndex(prev => (prev === index ? null : index));
  };

  const transformKey = (key) => {
    const keyWithSpaces = key.replace(/_/g, ' ');
    const lowerKey = key.toLowerCase();
    if ((lowerKey.includes("roas") || lowerKey.includes("acos")) && !lowerKey.includes("tacos")) {
      return keyWithSpaces.toUpperCase();
    }
    return keyWithSpaces.split(' ').map(word =>
      word.toLowerCase() === 'tacos' ? 'TACoS' : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    ).join(' ');
  };

  return (
    <div className="dashboard-grid">
      {isEmpty ? (
        loadingState?.dashboardSummary ? (
          Array.from({ length: visibleCount }).map((_, index) => (
            <div className="card p-3 " key={index}>
              <div className="skeleton skeleton-text w-100 mb-2" />
              <div className="skeleton skeleton-text w-75 mb-1" />
              <div className="skeleton skeleton-text w-50" />
              <div className="skeleton skeleton-text w-25" />
            </div>
          ))
        ) : (
          <div style={{ textAlign: "center", padding: "30px", fontWeight: "500" }}>
            No data found
          </div>
        )
      ) : (
        <>
        {prevData && (
          <KpiAccordion data={prevData} permission={permission} sectionPermissionMap={sectionPermissionMap} transformKey={transformKey} loadingState={loadingState} dashboardSummary={dashboardSummary} toggleTooltip={toggleTooltip} activeTooltipIndex={activeTooltipIndex} setActiveTooltipIndex={setActiveTooltipIndex} type={type} showWithGroupParent={true}/>
        )}
          {/* {displayedCards.map(([key, card], index) => {
            const pastChangeValue = parseFloat(card.past_change);
            const isNegative = !isNaN(pastChangeValue) && pastChangeValue < 0;

            return (
              <div
                className="card p-3 hover-card kpi-card-section"
                key={index}
                style={{ position: 'relative', cursor: 'pointer' }}
                onMouseLeave={() => setActiveTooltipIndex(null)}
              >
                <div className="icon-wrapper mb-3 d-flex justify-content-between">
                  <div
                    className="rounded-circle d-flex align-items-center justify-content-center"
                    style={{
                      width: '50px',
                      height: '50px',
                      backgroundColor: '#e6f0fa',
                      color: '#007bff'
                    }}
                  >
                    <i className={`bi ${card.icon || 'bi-bar-chart'} fs-4`}></i>
                  </div>
                  {card?.info && (
                    <div className="info-tooltip-wrapper position-relative">
                      <i
                        className="bi bi-info-circle ms-2 text-secondary info-icon"
                        style={{ cursor: 'pointer' }}
                        onClick={() => toggleTooltip(index)}
                      ></i>
                      {activeTooltipIndex === index && (
                        <div className="info-tooltip-box">
                          <p>{card?.info}</p>
                        </div>
                      )}
                    </div>
                  )}
                </div>

               
                <div className="price-tooltip-wrapper position-relative d-inline-block">
                  <h4 className="fw-bold mb-1" style={{ cursor: "pointer" }}>
                    {loadingState?.dashboardSummary ? <div className="skeleton skeleton-text w-75" /> : card.value}
                  </h4>
                  {!loadingState?.dashboardSummary && card.tooltip && (
                    <div className="price-tooltip-box">{card.tooltip}</div>
                  )}
                </div>

              
                <p className="mb-1 small">
                  {transformKey(key)}
                  {!loadingState?.dashboardSummary && 'change' in card && (
                    <span className="text-success ms-1" style={{ fontSize: "x-small" }}>
                      ({card.change})
                    </span>
                  )}
                </p>

             
                <span
                  className={`text-${card?.color === "red" ? "danger" : "success"}`}
                  style={{ fontSize: 'x-small' }}
                >
                  {loadingState?.dashboardSummary ? (
                    <div className="skeleton skeleton-text w-50" />
                  ) : (
                    <>
                     {card?.past_change ? `${card.past_change} ` : ""}
                  <span className="text-muted" style={{ fontSize: 'x-small' }}>
                    {card?.subtitle ? card.subtitle : ""}
                  </span>
                    </>
                  )}
                </span>
              </div>
            );
          })} */}

          {/* Show More Card */}
          {/* {allCards.length > visibleCount && (
            <div
              className="card p-3 shadow-sm d-flex align-items-center justify-content-center text-center"
              style={{ cursor: 'pointer', minHeight: '150px' }}
              onClick={() => setShowAll(!showAll)}
            >
              <i className={`bi ${showAll ? 'bi-dash-circle' : 'bi-plus-circle'} fs-3 signin-section-link mb-2`}></i>
              <p className="mb-0 signin-section-link">
                {showAll ? 'Show Less' : `Show ${remainingCards.length} More`}
              </p>
            </div>
          )} */}
        </>

      )}
      
      
      
    </div>
  );
};

export default SalesCard;
